import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/projector-display/components/DisplayContent.tsx");
